import {forwardRef, useContext, useEffect, useImperativeHandle} from "react";
import {Form} from "antd";
import {SGeneralForms} from "shj-components";

import {isEmpty} from "lodash-es";
import measureContext from "./measureContext.ts";
import styles from './index.module.less'
import {updateClue} from "@/services/saleOpServices.ts";
import {useSearchParams} from "react-router-dom";

export const Step1 = (props) => {
  const {detailInfo, setLoading} = useContext(measureContext)
  const [search] = useSearchParams()
  const customerId = search.get('customerId')
  const {dictionaryData} = props;
  const [form] = Form.useForm()

  useEffect(() => {
    if (!isEmpty(detailInfo)) {
      form.setFieldsValue({
        customerInfo: {
          name: detailInfo.name,
        },
        houseInfo: {
          buildingId: detailInfo.buildingId,
          doorNo: detailInfo.doorNo,
          houseStatus: detailInfo.houseStatus,
          houseKindCode: detailInfo.houseKindCode,
          layout: detailInfo.layout,
          constructArea: detailInfo.constructArea,
          innerArea: detailInfo.innerArea,
          houseHight: detailInfo.houseHight,
        }
      })
    }
  }, [detailInfo]);

  const handleValues = (values) => {
    return {
      name: values.customerInfo?.name,
      buildingId: values.houseInfo?.buildingId,
      doorNo: values.houseInfo?.doorNo,
      houseStatus: values.houseInfo?.houseStatus,
      houseKindCode: values.houseInfo?.houseKindCode,
      layout: values.houseInfo?.layout,
      constructArea: values.houseInfo?.constructArea,
      innerArea: values.houseInfo?.innerArea,
      houseHight: values.houseInfo?.houseHight,
    }
  }

  const onSubmit = async () => {
    return new Promise((resolve, reject) => {
      form.validateFields().then(values => {
        // updateDetail({loading: true})
        setLoading(true)
        const newValues: Record<string, any> = {
          ...values,
          id: detailInfo.clueId,
          customerInfo: {
            ...values.customerInfo,
            customerId,
          },
          dtlInfo: {}
        }
        updateClue(newValues)
            .then(() => {
              resolve(handleValues(newValues))
            })
            .catch(reject)
            .finally(() => setLoading(false))
      }).catch(reject)
    })
  }

  const onSaveCache = () => {
    const formValues = form.getFieldsValue()
    const values =   {
      ...formValues,
      id: detailInfo.clueId,
      customerInfo: {
        ...formValues.customerInfo,
        customerId,
      },
    }
    return Promise.resolve(handleValues(values))
  }

  if (props.stepRef) {
    props.stepRef.step1 = {onSubmit, onSaveCache}
  }

  return <div className={styles.stepFormBox}>
    <SGeneralForms
        formConfig={{form}}
        layout={'vertical'}
        configs={[{
          formItem: [
            {
              spanCol: 8,
              label: '客户',
              name: ['customerInfo', 'name'],
              required: true,
              rules: [{required: true, message: '不能为空'}],
              comConfig: {}
            },
            {
              spanCol: 8,
              label: '楼盘',
              name: ['houseInfo', 'buildingId'],
              required: true,
              rules: [{required: true, message: '不能为空'}],
              type: 'select',
              comConfig: {
                options: dictionaryData['buildList'],
                fieldNames: {label: 'name', value: 'id'}
              }
            },
            {
              spanCol: 8,
              label: '门牌号',
              name: ['houseInfo', 'doorNo'],
              required: true,
              rules: [{required: true, message: '不能为空'}],
              comConfig: {
                maxLength: 20,
              }
            },
            {
              spanCol: 8,
              label: '房屋状态',
              name: ['houseInfo', 'houseStatus'],
              required: true,
              rules: [{required: true, message: '不能为空'}],
              type: 'select',
              comConfig: {
                options: dictionaryData['houseStatus'],
                optionFilterProp: 'description',
                fieldNames: {label: 'description', value: 'key'}
              }
            },
            {
              spanCol: 8,
              label: '房屋类型',
              name: ['houseInfo', 'houseKindCode'],
              required: true,
              rules: [{required: true, message: '不能为空'}],
              type: 'select',
              comConfig: {
                options: dictionaryData['houseType'],
                optionFilterProp: 'description',
                fieldNames: {label: 'description', value: 'key'}
              }
            },
            {
              spanCol: 8,
              label: '户型',
              name: ['houseInfo', 'layout'],
              required: true,
              rules: [{required: true, message: '不能为空'}],
              type: 'select',
              comConfig: {
                options: dictionaryData['layout'],
                optionFilterProp: 'description',
                fieldNames: {label: 'description', value: 'key'}
              }
            },
            {
              spanCol: 8,
              label: '建筑面积',
              name: ['houseInfo', 'constructArea'],
              required: true,
              rules: [{required: true, message: '不能为空'}],
              type: 'inputNumber',
              comConfig: {
                precision: 2,
                min: 0.01,
                max: 999999999.99,
              }
            },
            {
              spanCol: 8,
              label: '套内面积',
              name: ['houseInfo', 'innerArea'],
               required: true,
              rules: [{required: true, message: '不能为空'}],
              type: 'inputNumber',
              comConfig: {
                precision: 2,
                min: 0.01,
                max: 999999999.99,
              }
            },
            {
              spanCol: 8,
              label: '层高',
              name: ['houseInfo', 'houseHight'],
               required: true,
              rules: [{required: true, message: '不能为空'}],
              type: 'inputNumber',
              comConfig: {
                precision: 2,
                min: 0.01,
                max: 999999999.99,
              }
            },
          ]
        }]}/>
  </div>
}